import React, { useMemo } from 'react';
import {Alert} from "react-bootstrap";
import { BsExclamationTriangleFill } from "react-icons/bs";
import LABELS from 'app/shared/constants/Literals';
import getBrandName from "app/shared/utils/BrandHelper";
import useGetPlatformInfo from 'hooks/useGetPlatformInfo';

type CartErorProps = {
    errorCode: string | null,
    onErrorClose: () => void
};

function getErrorMessageByCode(errorCode: string | null, isShellApp: boolean) {
    if (errorCode === 'PRICE_OVER_LIMIT_ERROR') {
       const brandObject = getBrandName();
       return LABELS.CART.priceOverLimitError.replace("{{cateringSite}}", brandObject.cateringUrl);
    }
    return isShellApp ? LABELS.CART.shellBannerErrorMessage : LABELS.CART.bannerErrorMessage;
}

function CartError({ errorCode, onErrorClose }: CartErorProps) {
    const { isShellApp } = useGetPlatformInfo();
    const errorMessage = useMemo(
        () => getErrorMessageByCode(errorCode, isShellApp),
        [errorCode, isShellApp],
    );
    if (!errorCode) {
        return null;
    }
    return (
        <Alert variant="danger" onClose={() => onErrorClose()} dismissible>
            <div className="d-inline-flex">
                <BsExclamationTriangleFill size={25} className="errorImage" />
                <Alert.Heading className="font-main errorText">
                    { isShellApp ? LABELS.CART.shellBannerError : LABELS.CART.bannerError }
                </Alert.Heading>
            </div>
            <p className="font-sub errorText">
                { errorMessage }
            </p>
        </Alert>
    );
}

export default CartError;
